import type { ProfileDTO } from '../api/types';
import type { OrganizationDataStatus, Profile, Rules } from '../model/types';

export const mapProfile = (profile: ProfileDTO): Profile => ({
  id: profile.id,
  email: profile.email,
  defaultOrganizationId: profile.defaultOrganizationId,
  analyticsId: profile.analyticsId,
  requiredActions: profile.requiredActions,
  organizations: profile.organizations.map((organization) => ({
    id: organization.id,
    name: organization.name,
    timezone: organization.timezone,
    currency: organization.currency,
    paymentOverdue: organization.paymentOverdue,
    webhookHash: organization.webhookHash,
    contractType: organization.contractType,
    dataStatus: organization.dataStatus as OrganizationDataStatus,
    isActive: organization.isActive,
    role: {
      id: organization.role.id,
      name: organization.role.name,
      rules: (organization.role.rules ?? {}) as Rules,
    },
  })),
});
